import { grey } from '@material-ui/core/colors'
import { BORAL_GREEN } from 'Constants/Theme/Theme.constants'
import Colors from 'Support/Theme/Colors/Colors'

const alertStyle = ({ theme }: { theme: any}) => ({
  wrapper: {
    backgroundColor: Colors.raven[50],
    padding: theme.spacing(1) * 1.5,
    maxWidth: '600px',
  },
  quantityConfirming: {
    color: BORAL_GREEN,
    fontSize: '60px',
    fontWeight: 'lighter',
  },
  contentText: {
    color: 'rgba(0,0,0,0.6)',
    fontSize: theme.typography.body2.fontSize,
    lineHeight: theme.typography.body2.lineHeight,
  },
  lightBulb: {
    marginRight: theme.spacing(1) * 1,
  },
})

export default alertStyle
